"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadCoupon = loadCoupon;
exports.loadCoupons = loadCoupons;
exports.loadUsersCoupon = loadUsersCoupon;
exports.createCoupon = createCoupon;
exports.updateCoupon = updateCoupon;
exports.watchLoadCoupon = watchLoadCoupon;
exports.watchLoadCoupons = watchLoadCoupons;
exports.watchLoadUsersCoupon = watchLoadUsersCoupon;
exports.watchCreateCoupon = watchCreateCoupon;
exports.watchUpdateCoupon = watchUpdateCoupon;
exports["default"] = exports.couponsSagas = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _utils = require("../../utils");

var _actions = _interopRequireDefault(require("./actions"));

var _marked = _regenerator["default"].mark(loadCoupon),
    _marked2 = _regenerator["default"].mark(loadCoupons),
    _marked3 = _regenerator["default"].mark(loadUsersCoupon),
    _marked4 = _regenerator["default"].mark(createCoupon),
    _marked5 = _regenerator["default"].mark(updateCoupon),
    _marked6 = _regenerator["default"].mark(watchLoadCoupon),
    _marked7 = _regenerator["default"].mark(watchLoadCoupons),
    _marked8 = _regenerator["default"].mark(watchLoadUsersCoupon),
    _marked9 = _regenerator["default"].mark(watchCreateCoupon),
    _marked10 = _regenerator["default"].mark(watchUpdateCoupon);

function loadCoupon(api, action) {
  var _action$payload, couponId, clientId, result;

  return _regenerator["default"].wrap(function loadCoupon$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _action$payload = action.payload, couponId = _action$payload.couponId, clientId = _action$payload.clientId;
          _context.next = 4;
          return api.getCoupon({
            couponId: couponId,
            clientId: clientId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          result = _context.sent;
          _context.next = 7;
          return (0, _effects.put)(_actions["default"].loadCouponSuccess(result));

        case 7:
          _context.next = 13;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          _context.next = 13;
          return (0, _effects.put)(_actions["default"].loadCouponError(_context.t0));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 9]]);
}

function loadCoupons(api, action) {
  var _action$payload2, clientId, limit, skip, identifier, sort, isAvailable, result;

  return _regenerator["default"].wrap(function loadCoupons$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.put)(_actions["default"].isLoading(true));

        case 3:
          _action$payload2 = action.payload, clientId = _action$payload2.clientId, limit = _action$payload2.limit, skip = _action$payload2.skip, identifier = _action$payload2.identifier, sort = _action$payload2.sort, isAvailable = _action$payload2.isAvailable;
          _context2.next = 6;
          return api.getCoupons({
            clientId: clientId,
            limit: limit,
            skip: skip,
            identifier: identifier,
            sort: sort,
            isAvailable: isAvailable
          }).then(function (p) {
            return p.request;
          });

        case 6:
          result = _context2.sent;
          _context2.next = 9;
          return (0, _effects.put)(_actions["default"].loadCouponsSuccess(result.data, result.meta));

        case 9:
          _context2.next = 11;
          return (0, _effects.put)(_actions["default"].isLoading(false));

        case 11:
          _context2.next = 17;
          break;

        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 17;
          return (0, _effects.put)(_actions["default"].loadCouponsError(_context2.t0));

        case 17:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 13]]);
}

function loadUsersCoupon(api, action) {
  var _action$payload3, clientId, couponId, limit, next, result;

  return _regenerator["default"].wrap(function loadUsersCoupon$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.put)(_actions["default"].isLoading(true));

        case 3:
          _action$payload3 = action.payload, clientId = _action$payload3.clientId, couponId = _action$payload3.couponId, limit = _action$payload3.limit, next = _action$payload3.next;
          _context3.next = 6;
          return api.getCouponUsers({
            clientId: clientId,
            couponId: couponId,
            limit: limit,
            next: next
          }).then(function (p) {
            return p.request;
          });

        case 6:
          result = _context3.sent;
          _context3.next = 9;
          return (0, _effects.put)(_actions["default"].loadUsersCouponSuccess(result.data, result.meta));

        case 9:
          _context3.next = 11;
          return (0, _effects.put)(_actions["default"].isLoading(false));

        case 11:
          _context3.next = 17;
          break;

        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 17;
          return (0, _effects.put)(_actions["default"].loadUsersCouponError(_context3.t0));

        case 17:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 13]]);
}

function createCoupon(api, action) {
  var payload, data;
  return _regenerator["default"].wrap(function createCoupon$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          payload = action.payload;
          _context4.next = 4;
          return api.createCoupon({
            payload: payload
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context4.sent;
          _context4.next = 7;
          return (0, _effects.put)(_actions["default"].createCouponSuccess(data));

        case 7:
          _context4.next = 13;
          break;

        case 9:
          _context4.prev = 9;
          _context4.t0 = _context4["catch"](0);
          _context4.next = 13;
          return (0, _effects.put)(_actions["default"].createCouponError(_context4.t0));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[0, 9]]);
}

function updateCoupon(api, action) {
  var _action$payload4, couponId, payload, data;

  return _regenerator["default"].wrap(function updateCoupon$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _action$payload4 = action.payload, couponId = _action$payload4._id, payload = (0, _objectWithoutProperties2["default"])(_action$payload4, ["_id"]);
          _context5.next = 4;
          return api.updateCoupon({
            couponId: couponId,
            payload: payload
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context5.sent;
          _context5.next = 7;
          return (0, _effects.put)(_actions["default"].updateCouponSuccess(data));

        case 7:
          _context5.next = 13;
          break;

        case 9:
          _context5.prev = 9;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 13;
          return (0, _effects.put)(_actions["default"].updateCouponError(_context5.t0));

        case 13:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[0, 9]]);
}

function watchLoadCoupon(api) {
  return _regenerator["default"].wrap(function watchLoadCoupon$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadCoupon), loadCoupon, api);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function watchLoadCoupons(api) {
  return _regenerator["default"].wrap(function watchLoadCoupons$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadCoupons), loadCoupons, api);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function watchLoadUsersCoupon(api) {
  return _regenerator["default"].wrap(function watchLoadUsersCoupon$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUsersCoupon), loadUsersCoupon, api);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function watchCreateCoupon(api) {
  return _regenerator["default"].wrap(function watchCreateCoupon$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].createCoupon), createCoupon, api);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function watchUpdateCoupon(api) {
  return _regenerator["default"].wrap(function watchUpdateCoupon$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].updateCoupon), updateCoupon, api);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

var couponsSagas = function couponsSagas(api) {
  return [(0, _effects.fork)(watchLoadCoupon, api), (0, _effects.fork)(watchLoadCoupons, api), (0, _effects.fork)(watchLoadUsersCoupon, api), (0, _effects.fork)(watchCreateCoupon, api), (0, _effects.fork)(watchUpdateCoupon, api)];
};

exports.couponsSagas = couponsSagas;
var _default = couponsSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map